
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    RADIO_CHANGE: 'radio-change',
    RADIO_SET_ERRORS: 'radio-set-errors',
    RADIO_REMOVE_ERRORS: 'radio-remove-errors',
};

const radioInputDataReducer = (state, action) => {
    //console.log("radio input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                radioButtons: action.radioButtons,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        /*case ACTIONS.SET_INITIAL_DATA: {
            
            //console.log(state.radioButtons);
            return {
                ...state,
                radioButtons: 
                    action.radioButtons,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                },
                disabled: state.disabled
            };
        }*/

        case ACTIONS.RADIO_CHANGE: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                value: action.value,
                prevValue: state.value,
                radioButtons: 
                    state.radioButtons.map((button) => {
                        //console.log(button.value + " " + action.value);
                        button.isChecked = false;
                        if (button.value == action.value) {
                            //console.log("change");
                            button.isChecked = true;
                        }

                        //console.log(button);
                        return button;
                    }),
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.RADIO_SET_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors
                }
            };
        }

        case ACTIONS.RADIO_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }

    }
}



export {ACTIONS, radioInputDataReducer};